// history.js
import "./jquery.mousewheel.min";

$(function () {

  /**
   * @コンテンツ横スクロール
   */

  var $mainContents = $(".c-block-scrollArea"),
    $scrollContents = $(".scrollArea"),
    contentsWidth = $(".historyBox").outerWidth(true),
    windowWidth = window.innerWidth - contentsWidth + 1,
    contentsNum = $(".historyBox:not('.type-intro')", $scrollContents).length,
    headerHeight = $(".l-header").outerHeight(),
    footerHeight = $(".l-footer").outerHeight(),
    chronologyHeight = $(".chronology").outerHeight(),
    windowHeight = document.documentElement.clientHeight,
    contentsPosition = $(".l-header").offset().left + 140;

  if (!$mainContents.length) return;
  //コンテンツサイズ

  $mainContents.css({
    "width": contentsWidth * contentsNum + windowWidth,
    "paddingTop": headerHeight,
  });
  $scrollContents.css({
    "paddingLeft": contentsPosition
  });
  var bgPosition = contentsPosition + "px " + "50%"
  $(".scrollArea").css({
    "background-position": bgPosition
  });


  $(".scrollArea .historyBox").css({
    "height": windowHeight - headerHeight - chronologyHeight - footerHeight
  });
  //
  // $(".c-block-scrollArea").addClass("is-visible");

  // $(".scrollArea .historyBox").css({
  //   "height": 725
  // });


  //スクロールスピード
  var speed = 30;

  //マウスホイールで横移動
  $('html').mousewheel(function (event, mov) {

    //ie firefox
    $(this).scrollLeft($(this).scrollLeft() - mov * speed);

    //webkit
    $('body').scrollLeft($('body').scrollLeft() - mov * speed);

    document.addEventListener('mousewheel DOMMouseScroll', { passive: false });
    // return false; //縦スクロール不可

  });

  $('.ageBox a[href^=\\#]').click(function () {
    var speed = 200, // ミリ秒
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? 'html' : href);

    var position;

    if (window.innerWidth <= 750) {
      position = target.offset().left - contentsPosition + 100;
    } else {
      position = target.offset().left - contentsPosition - 360;
    }


    $('html, body').animate({ scrollLeft: position }, speed, 'swing');
    return false;

  });


  /**
   * @年表
   */

  // 初期表示

  if ($(window).scrollLeft() == 0) {
    $(".ageBox:first-child").addClass("current");
  }


  // スクロール時
  $(window).scroll(function () {

    var scrollPosition = $(window).scrollLeft();

    $(".historyBox").each(function () {
      var $target = $(this),
        position = $target.offset().left - contentsPosition,
        pointNum = Math.floor(scrollPosition / contentsWidth),
        $current = $(".ageBox").eq(pointNum);

      if (scrollPosition >= position) {
        $current.addClass("current");
        if ($current.hasClass("on")) {
          $current.removeClass("on");
        }
      } else {
        $(".ageBox").not($current).removeClass("current on");
        $(".ageBox").each(function () {
          if ($(this).nextAll().hasClass("current")) {
            $(this).addClass("on");
          }
        });
      }

    });
  });

  /**
   * @吹き出し
   */
  // 表示位置
  $(".hoverPoint").each(function () {
    var balloonPoint = $(this).find(".historyPoint").css("left");
    $(this).find(".historyBaloon").css("left", balloonPoint);
  });


  $(".historyPoint").hover(
    function () {
      $(this).addClass("current");
      var $balloon = $(this).next(".historyBaloon");
      $balloon.addClass("current");
      // $balloon.stop(true, true).fadeIn(200);
    }, function () {
      var $balloon = $(this).next(".historyBaloon");
      $balloon.removeClass("current");
      // $balloon.stop(true, true).fadeOut(200);
      $(".historyPoint").removeClass("current");
    }
  );

  $(".historyBaloon").hover(
    function () {
      // $(this).stop(true, true).fadeIn(200);
      $(this).addClass("current");
      $(this).parent().find(".historyPoint").addClass("current");
    }, function () {
      // $(this).stop(true, true).fadeOut(200);
      $(this).removeClass("current");
      $(this).parent().find(".historyPoint").removeClass("current");
    }
  );

  // click時
  /*$("html").on("click", function(){
    if($(".historyBaloon").not(":hidden").length > 0){
      $(".historyBaloon").stop(true,true).fadeOut(200);
      $(".historyPoint").removeClass("current");
    } else{
      return false;
    }
  });

  $(".historyPoint").on("click", function(e){

    $(".historyPoint").removeClass("current");
    $(this).addClass("current");

    var $balloon = $(this).next(".historyBaloon");

    if($balloon.is(":hidden")){
      $balloon.stop(true,true).fadeIn(200);
      $(".historyBaloon").not($balloon).stop(true,true).fadeOut(200);
    } else {
      $balloon.stop(true,true).fadeOut(200);
      $(".historyPoint").removeClass("current");
    }
    e.stopPropagation();
  });

  $(".historyBaloon").on("click", function(e){
    e.stopPropagation();
  });*/


  $(".chronologyArea").addClass("is-visible");
  $(".c-block-scrollArea").addClass("is-visible");

  setTimeout(function () {
    $(".c-block-loader").hide();
  }, 1000)


  /**
   * @写真表示位置
   */


  if ($(".imgSet").length == 0) {
    return false;
  }

  $(".imgSet").each(function () {
    var positionT = $(this).height() / 2;
    $(this).css("marginTop", -positionT);
  });


  // $(window).on("load", function () {
  //
  //   if ($(".imgSet").length == 0) {
  //     return false;
  //   }
  //
  //   $(".imgSet").each(function () {
  //     var positionT = $(this).height() / 2;
  //     $(this).css("marginTop", -positionT);
  //   });
  // });

});
